import { useRoutes } from "react-router-dom";

// routes
import { AuthRoutes, MainRoutes } from "../index";

export const ThemeRoutes = () => {
  const data = MainRoutes();
  return useRoutes([AuthRoutes, data]);
};
